import React, { useState, useContext } from 'react';
import { Button, Progress } from 'rsuite';
import './add-accounts-excel.scss';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../../utils/i18n';
import { ActionLink, ModalWindow } from '../../../atoms';
import { UserContext, FilterContext } from '../../../../context';
import { AdminService } from '../../../../services';
import { useDropzone } from 'react-dropzone';
import fileDownload from 'js-file-download';
import axios from '../../../../utils/axios';
import axiosStat from 'axios';
import Dropzone from 'react-dropzone';
import config from '../../../../utils/config';

function AddAccountsExcel({ addAccountsModal, handleOpenSliderModal }) {
  const { filterDetails, setFilterDetails } = useContext(FilterContext);
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      '*.xlsx': [],
    },
    maxFiles: 1,
  });
  const [filesUploaded, setUploadedFiles] = useState(null);
  const [uploadpercent, setUploadPercent] = useState(0);
  const [fileUploadFailed, setFileUloadFailed] = useState(false);

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const handleOnCancel = e => {
    handleOpenSliderModal(false);
  };

  const onSampleDownload = e => {
    getPresignedURL();
  };

  const getPresignedURL = async () => {
    try {
      const response = await AdminService.downloadTemplate(userAccessToken, username);
      const result = response?.data?.data;
      let decodedUrl = decodeQueryParam(result);
      let splittedUrl = decodedUrl?.split('?');
      let downloadName = splittedUrl[0].substring(splittedUrl[0].lastIndexOf('/') + 1);
      handleDownload(result, downloadName);
    } catch (error) {}
  };

  const decodeQueryParam = p => {
    return decodeURIComponent(p.replace(/\+/g, ' '));
  };

  const handleDownload = (url, filename) => {
    const api = axiosStat.create({
      baseURL: axios.defaults.baseURL.slice(0, -4),
    });
    api
      .get(url, {
        responseType: 'blob',
      })
      .then(res => {
        fileDownload(res.data, filename);
      });
  };

  const onDrop = async files => {
    setUploadedFiles(files);
  };

  const onAdd = () => {
    onUpload();
  };

  const onUpload = async () => {
    const data = new FormData();
    data.append('file', filesUploaded[0]);
    try {
      let response = await axios.post(`${config.formUrl(AdminService.ADD_ACCONTS_EXCEL)}`, data, {
        onUploadProgress: progressEvent => {
          let precentage = parseInt((progressEvent.loaded / progressEvent.total) * 100);
          setUploadPercent(precentage);
        },
        headers: {
          'x-access-token': userAccessToken,
          'x-user': username,
        },
        responseType: 'json',
      });
      setFileUloadFailed(false);
      handleOpenSliderModal(false, true);
    } catch (error) {
      setFileUloadFailed(true);
    }
  };

  return (
    <div>
      <div className="attr-delete accounts-add-container">
        <ModalWindow
          className="fqa-modal--addAccounts"
          isOpen={addAccountsModal}
          onRequestClose={handleOnCancel}
          heading={t('admin.add.excel.header')}
          ariaHideApp={false}
          appElement={document.getElementById('app')}
        >
          <div className="excel-header-container">
            <div className="sample">{t('admin.add.sample.format')}:</div>
            <div className="sample align-download">
              <button className="return-insights" onClick={onSampleDownload}>
                <i className="eva  eva-download-outline"></i>
                {t('excel.download')}
              </button>
            </div>
          </div>
          <div className="container_excel">
            <Dropzone onDrop={onDrop}>
              {({ getRootProps, getInputProps }) => (
                <section className="container">
                  {!filesUploaded?.length && (
                    <div {...getRootProps({ className: 'dropzone' })}>
                      <input {...getInputProps()} />
                      <p className="drag_file drag_text">{t('admin.add.drag')}&nbsp;(.xls only)</p>
                      <p className="drag_file drag_text"> {t('admin.add.or')}</p>
                      <p className="drag_file text_dec">{t('admin.add.browse')}</p>
                    </div>
                  )}
                  <aside>
                    {filesUploaded?.length && (
                      <ul className="dropzone uploaded_file">
                        <i className="eva  eva-file-outline"></i>&nbsp;{filesUploaded[0].name}
                      </ul>
                    )}
                  </aside>
                </section>
              )}
            </Dropzone>
          </div>
          <div className="progress">
            {uploadpercent > 0 && uploadpercent < 100 && (
              <Progress.Line percent={uploadpercent} status="active" />
            )}
          </div>
          {fileUploadFailed && <div className="error">{t('admin.excel.error')}</div>}

          <div className="fqa-model-pa--actions">
            <button className="step-back" onClick={handleOnCancel}>
              {t('reportTable.campaign.delete.cancel')}
            </button>
            <button
              className="step-back step-add"
              onClick={onAdd}
              disabled={!filesUploaded?.length}
            >
              {t('admin.excel.upload')}
            </button>
          </div>
        </ModalWindow>
      </div>
    </div>
  );
}
export default AddAccountsExcel;
